import React from 'react'
import I18n from 'i18n'
import { WithAppsignal } from '../appsignal/AppsignalProvider'

export const ErrorBoundaryContext = React.createContext()

class ErrorBoundaryCls extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false
    }
  }

  componentDidCatch (error, info) {
    // Display fallback UI
    this.setState({ hasError: true })
    this.props.appsignal.sendError(error)
  }

  render () {
    if (this.state.hasError) {
      return (
        <p className='text-s text-muted'>
          {I18n.t(this.props.message)}
        </p>
      )
    }

    return this.props.children
  }
}

export const ErrorBoundary = WithAppsignal(ErrorBoundaryCls)

export const WithErrorBoundary = (Component, message) => props => {
  return (
    <ErrorBoundary message={message}><Component {...props} /></ErrorBoundary>
  )
}
